import { WhiteBlock } from 'components/Layout'
import { Font14 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const HistoryCard = styled(WhiteBlock)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.s};
  padding: ${theme.spacing.base};
`

export const HistoryCardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const HistoryCardTitle = styled.span`
  font-weight: bold;
  ${Font14}
`

export const HistoryFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.base};
`
export const HistoryLabel = styled.div`
  font-weight: normal;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const HistoryRowName = styled.div`
  color: ${theme.colors.darkeyGrey};
`

export const HistoryRowValue = styled.div`
  color: ${theme.colors.otterWarmBlack};
`

export const SubscriptionDateLabel = styled.div`
  font-weight: normal;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const SubscriptionHistoryPlanLabel = styled.span`
  margin-top: 2px;
`
